import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import FileSelectPage from "./pages/FileSelect";
import Traverse from "./pages/Traverse";
import Export from "./pages/Export";

const theme = createTheme({
  palette: {
    mode: "light",
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/file-select" replace />} />
          <Route path="/file-select" element={<FileSelectPage />} />
          <Route path="/traverse" element={<Traverse />} />
          <Route path="/export" element={<Export />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
